import { FormEvent, useState } from "react";
import { SiteHeader } from "../components/SiteHeader";
import { SiteFooter } from "../components/SiteFooter";

/**
 * Formulario de contacto — ADR-004 §D-4.7, punto 3 de "Criterios para dev".
 *
 * TODO(HubSpot): el envío real vive detrás del skill `crm-hubspot` (Proyectos/
 * skills/crm-hubspot/SKILL.md) y requiere `linea_de_negocio` obligatorio en
 * cada lead. No hay credenciales de HubSpot cableadas en esta sesión — el
 * formulario queda funcional en la UI (validación, estado de envío) pero NO
 * envía a ningún lado todavía. Deliberado: simular un envío que no llega a
 * HubSpot sería mentirle al visitante (valor Honestidad, regla de oro 3).
 * Cuando se cablee: POST a la integración de HubSpot con
 * `linea_de_negocio: "wasom"` fijo (ya está en el campo oculto de abajo).
 */
export function ContactPage() {
  const [status, setStatus] = useState<"idle" | "blocked">("idle");

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setStatus("blocked");
  }

  return (
    <div className="min-h-screen" style={{ background: "var(--bg)", color: "var(--text-1)" }}>
      <SiteHeader />
      <main className="mx-auto max-w-xl px-6 py-20">
        <h1 className="font-display text-3xl font-semibold">Hablemos</h1>
        <p className="mt-3" style={{ color: "var(--text-2)" }}>
          Contanos un poco de tu operación y te respondemos.
        </p>

        <form onSubmit={handleSubmit} className="mt-10 space-y-5">
          <input type="hidden" name="linea_de_negocio" value="wasom" />

          <div>
            <label htmlFor="name" className="mb-1 block text-sm font-medium">
              Nombre
            </label>
            <input
              id="name"
              name="name"
              type="text"
              required
              className="w-full rounded-[var(--radius-md)] border px-3 py-2"
              style={{ borderColor: "var(--border)", background: "var(--surface)" }}
            />
          </div>

          <div>
            <label htmlFor="email" className="mb-1 block text-sm font-medium">
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              className="w-full rounded-[var(--radius-md)] border px-3 py-2"
              style={{ borderColor: "var(--border)", background: "var(--surface)" }}
            />
          </div>

          <div>
            <label htmlFor="company" className="mb-1 block text-sm font-medium">
              Empresa
            </label>
            <input
              id="company"
              name="company"
              type="text"
              className="w-full rounded-[var(--radius-md)] border px-3 py-2"
              style={{ borderColor: "var(--border)", background: "var(--surface)" }}
            />
          </div>

          <div>
            <label htmlFor="message" className="mb-1 block text-sm font-medium">
              Contanos de tu operación
            </label>
            <textarea
              id="message"
              name="message"
              rows={4}
              className="w-full rounded-[var(--radius-md)] border px-3 py-2"
              style={{ borderColor: "var(--border)", background: "var(--surface)" }}
            />
          </div>

          <button
            type="submit"
            className="w-full rounded-[var(--radius-lg)] px-6 py-3 font-semibold"
            style={{ background: "var(--brand)", color: "var(--brand-on)" }}
          >
            Enviar
          </button>

          {status === "blocked" && (
            <p
              role="status"
              className="rounded-[var(--radius-md)] border px-4 py-3 text-sm"
              style={{ borderColor: "var(--status-warn)", color: "var(--status-warn-ink)", background: "var(--brand-subtle)" }}
            >
              El envío automático todavía está en configuración. Mientras tanto, escribinos
              directo a{" "}
              <a href="mailto:hola@compropass.app" className="underline">
                hola@compropass.app
              </a>{" "}
              y te respondemos igual.
            </p>
          )}
        </form>
      </main>
      <SiteFooter />
    </div>
  );
}
